import React, { Component } from "react";
import { Link } from "react-router-dom";
import { theme } from "../../assets/theme/theme";

class TrainingRequestCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      step: 1,
      form: {
        course_title: "",
        provider: "",
        training_type: "",
        category: "",
        start_date: "",
        end_date: "",
        number_of_days: "",
        venue: "",
        location: "",
        description: "",
        course_fee: "",
        travel: "",
        accommodation: "",
        meal: "",
        miscellaneous: "",
        reason: "",
      },
    };
  }

  updateForm = (key, value) => {
    this.setState({
      form: {
        ...this.state.form,
        [key]: value,
      },
    });
  };

  nextStep = () => {
    if (this.state.step < 4) {
      this.setState({ step: this.state.step + 1 });
    }
  };

  prevStep = () => {
    if (this.state.step > 1) {
      this.setState({ step: this.state.step - 1 });
    }
  };

  getTotalCost = () => {
    const { course_fee, travel, accommodation, meal, miscellaneous } = this.state.form;

    return (
      Number(course_fee || 0) +
      Number(travel || 0) +
      Number(accommodation || 0) +
      Number(meal || 0) +
      Number(miscellaneous || 0)
    ).toFixed(2);
  };

  renderStepIndicator() {
    const steps = ["Training Details", "Cost & Funding", "Documents", "Review & Submit"];

    return (
      <div style={{ display: "flex", margin: "24px 0 32px" }}>
        {steps.map((label, index) => {
          const stepNo = index + 1;
          const active = this.state.step >= stepNo;

          return (
            <div key={label} style={{ flex: 1, textAlign: "center", position: "relative" }}>
              <div
                style={{
                  width: 24,
                  height: 24,
                  borderRadius: "50%",
                  margin: "0 auto 8px",
                  background: active ? theme.colors.brand.primary : "#E5E7EB",
                  color: active ? "#fff" : "#64748B",
                  fontSize: 12,
                  fontWeight: 700,
                  lineHeight: "24px",
                }}
              >
                {stepNo}
              </div>
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 700,
                  color: active ? theme.colors.brand.primary : "#94A3B8",
                }}
              >
                {label}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  renderStep1() {
    const f = this.state.form;

    return (
      <div>
        <h5 style={sectionTitle}>Training Information</h5>

        <div style={grid2}>
          {this.renderInput("Course / Program Title", "course_title", f.course_title)}
          {this.renderInput("Provider / Organiser", "provider", f.provider)}

          {this.renderSelect("Training Type", "training_type", f.training_type, [
            "Within Malaysia",
            "Overseas",
            "Online",
          ])}

          {this.renderSelect("Training Category", "category", f.category, [
            "Technical",
            "Leadership",
            "Finance",
            "Marketing",
          ])}

          {this.renderInput("Course Date (Start)", "start_date", f.start_date, "date")}
          {this.renderInput("Course Date (End)", "end_date", f.end_date, "date")}
          {this.renderInput("Number of Day(s)", "number_of_days", f.number_of_days, "number")}
          {this.renderInput("Location / City", "location", f.location)}
        </div>

        {this.renderTextarea("Venue", "venue", f.venue)}
        {this.renderTextarea("Course Name & Brief Description", "description", f.description)}
      </div>
    );
  }

  renderStep2() {
    const f = this.state.form;

    return (
      <div>
        <h5 style={sectionTitle}>Estimated Costing (RM)</h5>

        {this.renderCostRow("Course fee", "course_fee", f.course_fee)}
        {this.renderCostRow("Air ticket / Travel insurance / Visa", "travel", f.travel)}
        {this.renderCostRow("Accommodation", "accommodation", f.accommodation)}
        {this.renderCostRow("Meal allowance", "meal", f.meal)}
        {this.renderCostRow("Miscellaneous", "miscellaneous", f.miscellaneous)}

        <div
          style={{
            marginTop: 16,
            padding: 16,
            background: "#F8FAFC",
            borderRadius: 8,
            display: "flex",
            justifyContent: "space-between",
            fontWeight: 800,
          }}
        >
          <span>Total (RM)</span>
          <span>{this.getTotalCost()}</span>
        </div>

        {this.renderTextarea("Training Reason(s)", "reason", f.reason)}
      </div>
    );
  }

  renderStep3() {
    return (
      <div>
        <h5 style={sectionTitle}>Documents</h5>

        {this.renderUploadRow("Course content & timetable / schedule")}
        {this.renderUploadRow("Trainer's profile")}
        {this.renderUploadRow("Course fee quotation")}

        <div
          style={{
            marginTop: 20,
            border: "1px dashed #CBD5E1",
            borderRadius: 12,
            padding: 40,
            textAlign: "center",
            color: "#64748B",
          }}
        >
          <div style={{ fontSize: 36, marginBottom: 10 }}>☁</div>
          <div style={{ fontWeight: 700 }}>Drag and drop files here</div>
          <button style={secondaryButton}>Upload More Files</button>
          <div style={{ fontSize: 12, marginTop: 8 }}>PDF, JPG, PNG only. Max 10MB each.</div>
        </div>
      </div>
    );
  }

  renderStep4() {
    const f = this.state.form;

    return (
      <div>
        <h5 style={sectionTitle}>Review Your Request</h5>

        {this.renderReviewBox("Training Details", [
          ["Course Title", f.course_title || "-"],
          ["Provider", f.provider || "-"],
          ["Training Type", f.training_type || "-"],
          ["Start Date", f.start_date || "-"],
          ["End Date", f.end_date || "-"],
          ["Venue", f.venue || "-"],
        ])}

        {this.renderReviewBox("Estimated Costing", [
          ["Course Fee", `RM ${Number(f.course_fee || 0).toFixed(2)}`],
          ["Travel", `RM ${Number(f.travel || 0).toFixed(2)}`],
          ["Accommodation", `RM ${Number(f.accommodation || 0).toFixed(2)}`],
          ["Meal", `RM ${Number(f.meal || 0).toFixed(2)}`],
          ["Miscellaneous", `RM ${Number(f.miscellaneous || 0).toFixed(2)}`],
          ["Total", `RM ${this.getTotalCost()}`],
        ])}

        {this.renderReviewBox("Training Reason", [["Reason", f.reason || "-"]])}
      </div>
    );
  }

  renderInput(label, key, value, type = "text") {
    return (
      <div style={{ marginBottom: 16 }}>
        <label style={labelStyle}>{label}</label>
        <input
          type={type}
          value={value}
          onChange={(e) => this.updateForm(key, e.target.value)}
          style={inputStyle}
        />
      </div>
    );
  }

  renderSelect(label, key, value, options) {
    return (
      <div style={{ marginBottom: 16 }}>
        <label style={labelStyle}>{label}</label>
        <select
          value={value}
          onChange={(e) => this.updateForm(key, e.target.value)}
          style={inputStyle}
        >
          <option value="">Select</option>
          {options.map((x) => (
            <option key={x} value={x}>{x}</option>
          ))}
        </select>
      </div>
    );
  }

  renderTextarea(label, key, value) {
    return (
      <div style={{ marginBottom: 16 }}>
        <label style={labelStyle}>{label}</label>
        <textarea
          value={value}
          onChange={(e) => this.updateForm(key, e.target.value)}
          rows={5}
          style={{ ...inputStyle, height: "auto", paddingTop: 10 }}
        />
      </div>
    );
  }

  renderCostRow(label, key, value) {
    return (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 220px",
          gap: 16,
          alignItems: "center",
          marginBottom: 12,
        }}
      >
        <label style={labelStyle}>{label}</label>
        <input
          type="number"
          value={value}
          onChange={(e) => this.updateForm(key, e.target.value)}
          style={inputStyle}
        />
      </div>
    );
  }

  renderUploadRow(label) {
    return (
      <div
        style={{
          border: "1px solid #E5E7EB",
          borderRadius: 8,
          padding: "14px 16px",
          marginBottom: 12,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span style={{ fontWeight: 700, color: "#334155" }}>{label}</span>
        <button style={secondaryButton}>Choose File</button>
      </div>
    );
  }

  renderReviewBox(title, rows) {
    return (
      <div
        style={{
          border: "1px solid #E5E7EB",
          borderRadius: 10,
          marginBottom: 16,
          overflow: "hidden",
        }}
      >
        <div style={{ background: "#F8FAFC", padding: 14, fontWeight: 800 }}>{title}</div>
        <div style={{ padding: 16 }}>
          {rows.map((row) => (
            <div
              key={row[0]}
              style={{
                display: "grid",
                gridTemplateColumns: "220px 1fr",
                marginBottom: 10,
                fontSize: 13,
              }}
            >
              <div style={{ color: "#64748B", fontWeight: 700 }}>{row[0]}</div>
              <div style={{ color: "#0F172A" }}>{row[1]}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderStepContent() {
    if (this.state.step === 1) return this.renderStep1();
    if (this.state.step === 2) return this.renderStep2();
    if (this.state.step === 3) return this.renderStep3();
    return this.renderStep4();
  }

  render() {
    return (
      <div style={{ padding: 24 }}>
        <div style={{ marginBottom: 20 }}>
          <h4 style={{ margin: 0, fontWeight: 800 }}>Create Training Request</h4>
        </div>

        <div
          style={{
            background: "#fff",
            border: "1px solid #E5E7EB",
            borderRadius: 12,
            padding: 24,
          }}
        >
          {this.renderStepIndicator()}
          {this.renderStepContent()}

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 28,
            }}
          >
            {this.state.step === 1 ? (
              <Link to="/training/request" style={secondaryButtonLink}>Back</Link>
            ) : (
              <button onClick={this.prevStep} style={secondaryButton}>Back</button>
            )}

            {this.state.step < 4 ? (
              <button onClick={this.nextStep} style={primaryButton}>Next</button>
            ) : (
              <button style={primaryButton}>Submit Request</button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const sectionTitle = {
  fontSize: 15,
  fontWeight: 800,
  marginBottom: 18,
  color: "#0F172A",
};

const grid2 = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 16,
};

const labelStyle = {
  display: "block",
  fontSize: 12,
  fontWeight: 700,
  color: "#334155",
  marginBottom: 8,
};

const inputStyle = {
  width: "100%",
  height: 40,
  border: "1px solid #E5E7EB",
  borderRadius: 8,
  padding: "0 12px",
  fontSize: 13,
  outline: "none",
};

const primaryButton = {
  background: theme.colors.brand.primary,
  color: "#fff",
  border: 0,
  borderRadius: 8,
  padding: "10px 18px",
  fontWeight: 800,
  cursor: "pointer",
};

const secondaryButton = {
  background: "#fff",
  color: "#334155",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "9px 16px",
  fontWeight: 700,
  cursor: "pointer",
};

const secondaryButtonLink = {
  ...secondaryButton,
  textDecoration: "none",
  display: "inline-block",
};

export default TrainingRequestCreate;